import React from "react";
import { Card, Typography, Divider, Image, Row, Col, Button, Tag } from "antd";
import { useTranslation } from "react-i18next";

const { Paragraph, Text } = Typography;

interface Props {
  taskDetail: any[];
  sponsors: any[];
  evaluation?: any;
}

const TabInformation: React.FC<Props> = ({
  taskDetail,
  sponsors,
  evaluation,
}) => {
  const { t } = useTranslation();

  return (
    <>
      <Card>
        {taskDetail.length > 0 &&
          taskDetail?.map((task, index) => (
            <div
              key={index} // ใส่ key สำหรับ React
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                marginBottom: "30px",
              }}
            >
              <Image
                src={
                  task.img?.startsWith("/data/")
                    ? `${process.env.REACT_APP_API}${task.img}`
                    : task.img
                }
                className="responsive-image"
                alt="pictop"
              />
            </div>
          ))}

        <Divider />

        {/* sponsor */}
        {sponsors.length > 0 && (
          <>
            <Row style={{ marginTop: 15 }}>
              <Col xs={24} sm={24} md={4} lg={3} xl={3}>
                <Paragraph
                  className="custom-paragraph"
                  style={{ fontWeight: "bold" }}
                >
                  {t("Sponsored by")} :
                </Paragraph>
              </Col>
              <Col xs={24} sm={24} md={20} lg={21} xl={21}>
                <Row
                  gutter={[16, 16]}
                  justify="start"
                  style={{ marginLeft: 1 }}
                >
                  {sponsors.map((sponsor, index) => (
                    <Col
                      key={index}
                      xs={12}
                      sm={8}
                      md={6}
                      lg={4}
                      style={{
                        display: "flex",
                        justifyContent: "center",
                      }}
                    >
                      {sponsor.url ? (
                        <a
                          href={`http://${sponsor.url}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{
                            padding: "16px",
                            borderRadius: "8px",
                            backgroundColor: "#fff",
                            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            height: "100px",
                            width: "100%",
                          }}
                        >
                          <Image
                            src={`${process.env.REACT_APP_API}${sponsor.logo}`}
                            alt={sponsor.name}
                            preview={false}
                            style={{
                              maxWidth: "100%",
                              maxHeight: "80px",
                              objectFit: "contain",
                            }}
                          />
                        </a>
                      ) : (
                        <div
                          style={{
                            padding: "16px",
                            borderRadius: "8px",
                            backgroundColor: "#fff",
                            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            height: "100px",
                            width: "100%",
                          }}
                        >
                          <Image
                            src={`${process.env.REACT_APP_API}${sponsor.logo}`}
                            alt={sponsor.name}
                            preview={false}
                            style={{
                              maxWidth: "100%",
                              maxHeight: "80px",
                              objectFit: "contain",
                            }}
                          />
                        </div>
                      )}
                    </Col>
                  ))}
                </Row>
              </Col>
            </Row>

            <Divider />
          </>
        )}

        {taskDetail.length > 0 ? (
          taskDetail.map((task, index) => (
            <div key={index} style={{ margin: "30px 0px 50px 0px" }}>
              {/* Detail Task */}
              {(() => {
                // Helper function to strip HTML tags
                const stripHtmlTags = (html: string): string => {
                  if (!html) return "";
                  const tmp = document.createElement("DIV");
                  tmp.innerHTML = html;
                  return tmp.textContent || tmp.innerText || "";
                };

                // First, try to parse JSON
                let informationObj: any = null;

                try {
                  // Parse the information (might be string or already object)
                  informationObj =
                    typeof task?.information === "string"
                      ? JSON.parse(task.information || "")
                      : task?.information;

                  // If it's still a string after parsing, try to parse again
                  if (typeof informationObj === "string") {
                    try {
                      informationObj = JSON.parse(informationObj || "");
                      console.log("Double parsed information:", informationObj);
                    } catch (e) {
                      console.log(
                        "Second parse failed, using first parse result",
                      );
                    }
                  }
                } catch (e) {
                  console.error("Failed to parse task information:", e);
                  // If parsing fails, show as plain text
                  const plainText = stripHtmlTags(task.information || "");
                  return (
                    <Row>
                      <Col xs={24} sm={6} md={4} lg={3} xl={3}>
                        <Paragraph className="custom-paragraph">
                          {t("Task Details")} :{" "}
                        </Paragraph>
                      </Col>
                      <Col xs={24} sm={18} md={20} lg={21} xl={21}>
                        <Paragraph className="custom-paragraph">
                          {plainText || " - "}
                        </Paragraph>
                      </Col>
                    </Row>
                  );
                }

                // If it's an array, take the first element
                let dataObj = informationObj;
                if (
                  Array.isArray(informationObj) &&
                  informationObj.length > 0
                ) {
                  dataObj = informationObj[0];
                }

                if (
                  dataObj &&
                  typeof dataObj === "object" &&
                  !Array.isArray(dataObj)
                ) {
                  const expectedKeys = [
                    "information",
                    "datasetdetail",
                    "submission",
                    "evaluation",
                    "rules",
                  ];
                  const hasAnyKey = expectedKeys.some((key) => key in dataObj);

                  if (hasAnyKey) {
                    const sections = [
                      { key: "information", label: t("Information") },
                      { key: "datasetdetail", label: t("Dataset Detail") },
                      { key: "submission", label: t("Submission") },
                      { key: "evaluation", label: t("Evaluation") },
                      { key: "rules", label: t("Rules") },
                    ];

                    return sections.map((section) => {
                      const sectionData = dataObj[section.key];
                      if (sectionData) {
                        return (
                          <React.Fragment key={section.key}>
                            <Row style={{ marginBottom: "20px" }}>
                              <Col xs={24} sm={6} md={4} lg={3} xl={3}>
                                <Paragraph
                                  className="custom-paragraph"
                                  style={{ fontWeight: "bold" }}
                                >
                                  {section.label} :{" "}
                                </Paragraph>
                              </Col>
                              <Col xs={24} sm={18} md={20} lg={21} xl={21}>
                                <div
                                  className="custom-paragraph"
                                  style={{ pointerEvents: "none" }}
                                  contentEditable={false}
                                  dangerouslySetInnerHTML={{
                                    __html: sectionData,
                                  }}
                                />
                              </Col>
                            </Row>
                            <Divider />
                          </React.Fragment>
                        );
                      }
                      return null;
                    });
                  } else {
                    console.log("✗ No expected keys found, using fallback");
                  }
                } else {
                  console.log("✗ Not a valid object, using fallback");
                }

                // Fallback: show as plain text
                const plainText = stripHtmlTags(
                  typeof informationObj === "string"
                    ? informationObj
                    : task.information || "",
                );

                return (
                  <Row>
                    <Col xs={24} sm={6} md={4} lg={3} xl={3}>
                      <Paragraph className="custom-paragraph">
                        {t("Task Details")} :{" "}
                      </Paragraph>
                    </Col>
                    <Col xs={24} sm={18} md={20} lg={21} xl={21}>
                      <Paragraph className="custom-paragraph">
                        {plainText || " - "}
                      </Paragraph>
                    </Col>
                  </Row>
                );
              })()}

              {/* Task Type */}
              <Row>
                <Col xs={8} sm={6} md={4} lg={3} xl={3}>
                  <Paragraph
                    className="custom-paragraph"
                    style={{ fontWeight: "bold" }}
                  >
                    {t("Task Type")} :{" "}
                  </Paragraph>
                </Col>
                <Col xs={16} sm={18} md={20} lg={21} xl={21}>
                  <Paragraph className="custom-paragraph">
                    {task.type === 1
                      ? "Event"
                      : task.type === 2
                        ? "General"
                        : " - "}
                  </Paragraph>
                </Col>
              </Row>
              <Divider />

              {/* submission type */}
              <Row>
                <Col xs={8} sm={6} md={4} lg={3} xl={3}>
                  <Paragraph
                    className="custom-paragraph"
                    style={{ fontWeight: "bold" }}
                  >
                    {t("Submission Type")} :{" "}
                  </Paragraph>
                </Col>
                <Col xs={16} sm={18} md={20} lg={21} xl={21}>
                  <Paragraph className="custom-paragraph">
                    {task.submission_type === 1
                      ? "Model Submission"
                      : task.submission_type === 2
                        ? "Result File Submission"
                        : " - "}
                  </Paragraph>
                </Col>
              </Row>
              <Divider />

              {/* Tags */}
              <Row>
                <Col xs={8} sm={6} md={4} lg={3} xl={3}>
                  <Paragraph
                    className="custom-paragraph"
                    style={{ fontWeight: "bold" }}
                  >
                    {t("Tag")} :{" "}
                  </Paragraph>
                </Col>
                <Col xs={16} sm={18} md={20} lg={21} xl={21}>
                  {(JSON.parse(task.tags) || []).length > 0 ? (
                    JSON.parse(task.tags).map((tag: string, index: number) => (
                      <Tag key={`${tag}-${index}`}>{tag?.trim() || " - "}</Tag>
                    ))
                  ) : (
                    <Col xs={16} sm={18} md={20} lg={21} xl={21}>
                      <Paragraph className="custom-paragraph"> - </Paragraph>
                    </Col>
                  )}
                </Col>
              </Row>
              <Divider />

              {/* Team Size */}
              <Row>
                <Col xs={8} sm={6} md={4} lg={3} xl={3}>
                  <Paragraph
                    className="custom-paragraph"
                    style={{ fontWeight: "bold" }}
                  >
                    {t("Team Size")} :{" "}
                  </Paragraph>
                </Col>
                <Col xs={16} sm={18} md={20} lg={21} xl={21}>
                  <Paragraph className="custom-paragraph">
                    {task.min_size != null && task.team_size != null
                      ? task.min_size === task.team_size
                        ? `${t("Exactly")} ${task.team_size} ${t("member")}`
                        : `${task.min_size} - ${task.team_size} ${t("members")}`
                      : task.team_size != null
                      ? `${t("Max")} ${task.team_size} ${t("members")}`
                      : " - "}
                  </Paragraph>
                </Col>
              </Row>
            </div>
          ))
        ) : (
          <p style={{ textAlign: "center", color: "gray" }}>
            {t("No information available")}
          </p>
        )}
      </Card>
    </>
  );
};

export default TabInformation;
